import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {
  acceptedNotification: any = 0;
  reprocessNotification: any = 0;
  rescanNotification: any = 0;
  private readonly config: any;
  constructor(private readonly http: HttpClient, private readonly configService: AppConfigService,) {
    this.config = configService.config;
  }

  getAllScanners() {
    return this.http.get(`${this.config.apiUrl}slide/scanner/active`);
  }

  getScannerFolders(scannerId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/${scannerId}/folders`);
  }

  getFolderData(folderId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/${folderId}/slides`);
  }

  getPageWiseFolderdata(folderId: any, pageNo: number, pageSize: number) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/${folderId}/slides?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getAllData(payLoad: any) {
    return this.http.post(`${this.config.apiUrl}slide/scanner/gallery`, payLoad);
  }

  getReprocessSlides(scannerId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=REPROCESS&scannerId=${scannerId}`);
  }

  getStatusSlides(status: any, scannerId: any, folderId: any) {
    if (folderId) {
      return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}&folderId=${folderId}`);
    } else {
      return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}`);
    }
  }

  getRefreshData(sourceId: any, folderId: any, timestamp: any, lastScanTime: any) {
    let data = {
      "sourceId": sourceId,
      "folderId": folderId,
      "delay": this.config.galleryRefreshTimer,
      "lastScanTime": lastScanTime
    }
    return this.http.post(`${this.config.apiUrl}slide/scanner/slideUpdates`, data);
  }

  searchCall(payLoad: any) {
    return this.http.post(`${this.config.apiUrl}slide/search`, payLoad);
  }

  getStatusSlidePageWise(status: any, scannerId: any, folderId: any, pageNo: any, pageSize: any, artefact: any, sortBy: string, sortSeq: string, reviewFilter: string) {
    let finalSortSequence: string = (sortBy == 'NAME') ? 'ASCENDING' : 'DESCENDING';
    if (folderId) {
      if (artefact && artefact != 'All') {
        return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}&pageNo=${pageNo}&pageSize=${pageSize}&folderId=${folderId}&feature=${artefact}&sortBy=${sortBy}&sortType=${finalSortSequence}&reviewFilter=${reviewFilter}`);
      } else {
        return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}&pageNo=${pageNo}&pageSize=${pageSize}&folderId=${folderId}&sortBy=${sortBy}&sortType=${finalSortSequence}&reviewFilter=${reviewFilter}`);
      }
    } else if (artefact && artefact != 'All') {
      return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}&pageNo=${pageNo}&pageSize=${pageSize}&feature=${artefact}&sortBy=${sortBy}&sortType=${finalSortSequence}&reviewFilter=${reviewFilter}`);
    } else {
      return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=${status}&scannerId=${scannerId}&pageNo=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${finalSortSequence}&reviewFilter=${reviewFilter}`);
    }
  }

  getRescanSlides(scannerId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=RESCAN&scannerId=${scannerId}`);
  }

  getAcceptedSlides(scannerId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/issuedSlides?issueStatus=ACCEPTED&scannerId=${scannerId}`);
  }

  getManualQualtificationResult(reviewId: any, auto: any) {
    return this.http.get(`${this.config.apiUrl}slide/v3/annotation/QuantificationResult?reviewId=${reviewId}&auto=${auto}`);
  }

  getQuantificationResults(slideId: number, roi: number, autoFlag: boolean) {
    return this.http.get(`${this.config.apiUrl}slide/v3/annotation/quantificationResult/roi?slideId=${slideId}&auto=${autoFlag}&roi=${roi}`);
  }

  getAllQualtificationResult(slideId: number, autoFlag: boolean) {
    return this.http.get(`${this.config.apiUrl}slide/v3/annotation/slide/quantificationResult?slideId=${slideId}&auto=${autoFlag}`);

  }

  getProfileDetailsForImage(slideId: any) {
    return this.http.get(`${this.config.apiUrl}slide/profile/snapshot?slideId=${slideId}`);
  }


  getSlideMetadata(slideId: any) {
    return this.http.get(`${this.config.apiUrl}slide/metadata?slideId=${slideId}`);
  }

  getSlideSize(slideId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/slideSize?slideId=${slideId}`);
  }

  getReviewId(slideId: any) {
    return this.http.get(`${this.config.apiUrl}slide/v3/annotation/quantificationResult?slideId=${slideId}&qc=true`);
  }

  getQcstatusCount(folderId: any, recursive: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/qcStatusCount?folderId=${folderId}&recursive=${!!recursive}`);
  }

  getQcstatusSourceCount(sourdeId: any) {
    return this.http.get(`${this.config.apiUrl}slide/scanner/qcStatusCountForSource?sourceId=${sourdeId}&recursive=${false}`);
  }

  getGroupedStatusCount(scannerId: number, folderId?: number, sameLevel?: boolean) {
    let params = new HttpParams().set('scannerId', scannerId.toString());

    if (folderId !== undefined) {
      params = params.set('folderId', folderId.toString());
    }
    if (sameLevel !== undefined) {
      params = params.set('sameLevel', sameLevel.toString());
    }

    return this.http.get(`${this.config.apiUrl}slide/scanner/groupedStatusCount`, { params });
  }

  triggerAnalysis(data: any) {
    return this.http.post(`${this.config.apiUrl}slide/analysisBatch/submit`, data);
  }

  getSlideSchema(slide: any) {
    return this.http.get(`${this.config.tileUrl}${this.config?.tileGateway ? 'ts' : 'tiles'}/schema?query=${slide.identifier}`)
  }

  getSlideSchemaFromLocation(slideLocation: any, identifier: any) {
    const encodedPath = btoa(String.fromCharCode(...new TextEncoder().encode(slideLocation)));
    return this.http.get(`${this.config.tileUrl}${this.config?.tileGateway ? 'ts' : 'tiles'}/schema?query=${encodedPath}&identifier=${identifier}`)
  }

  autoRefreshNotification(sourceId: any, folderId: any) {
    this.getNotificationCount(sourceId, folderId).subscribe((result: any) => {
      if (result.success) {
        this.acceptedNotification = result.data.accepted;
        this.reprocessNotification = result.data.reprocess;
        this.rescanNotification = result.data.rescan;
      } else {
        this.acceptedNotification = 0;
        this.reprocessNotification = 0;
        this.rescanNotification = 0;
      }
    });
  }

  getNotificationCount(sourceId: any, folderId: any) {
    if (!folderId) {
      return this.http.get(`${this.config.apiUrl}slide/notification/scanner?scannerId=${sourceId}`);
    } else {
      return this.http.get(`${this.config.apiUrl}slide/notification/scanner?scannerId=${sourceId}&folderId=${folderId}`);
    }

  }

  clearNotification(sourceId: any, folderId: any, source: any) {
    if (!folderId) {
      return this.http.get(`${this.config.apiUrl}slide/notification/read?scannerId=${sourceId}&status=${source}`);
    } else {
      return this.http.get(`${this.config.apiUrl}slide/notification/read?folderId=${folderId}&scannerId=${sourceId}&status=${source}`);
    }

  }


  removeResults(payLoad: any) {
    return this.http.post(`${this.config.apiUrl}slide/delete-results`, payLoad);
  }

  syncManualResults(payLoad: any) {
    return this.http.post(`${this.config.apiUrl}slide/qc-annotation/add-manual-files`, payLoad);
  }

  generateThumbnails(payload: any) {
    return this.http.post(`${this.config.apiUrl}tiles/saveMetaImages`, payload);
  }

}
